<script>

	/* IMPORT: SVELTE/KIT */
	import { onMount, tick } from 'svelte';
	import { page } from '$app/stores';
  
	/* IMPORT: 3RD-PARTY */
	
	/* IMPORT: CUSTOM JS */
	import { restProp }	from '$lib/script/restprop.js';

	export let base = 
	{ 
		id: 'main',
		class: { 
			prefix: true, 
			value: 'main' 
		}
	};

	let main = null;


	/* Svelte Methods */
	
	onMount( async () =>
	{
		// #Await...
		//await tick();

		$$restProps = restProp({
			type: 'Main',
			restProp: $$restProps,
			base: base,
			//required: ['title']
		});

	});
  
</script>

<main bind:this={ main } {...$$restProps}>
	<slot />
</main>

<style lang='scss'>

	:global( .site ) 
	{
		overflow: hidden;
		background-color: var(--clr-black-static);
	}

	:global( main ) 
	{ 
		width: 100%;
		max-width: theme( 'screens.xxxl' );
		margin: 0 auto;
		background-color: var(--clr-white-static);
	}
</style>